import React from 'react';

export interface TableRowProps {
  children: React.ReactNode | React.ReactNode[];
}

const TableRow = ({ children, ...props }: React.HTMLProps<HTMLTableRowElement>) => {
  return <tr {...props}>{children}</tr>;
};

export default TableRow;
